"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};

var SectionContainer = _styledComponents2.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #fafafa;\n  padding: 2rem 0;\n\n  & > *:not(:last-child) {\n    margin-bottom: 2rem;\n  }\n\n  @media (max-width: 20rem) {\n    width: 20rem;\n  }\n\n  @media all and (min-width: 40rem) {\n    padding: 3rem 0;\n\n    & > *:not(:last-child) {\n      margin-bottom: 3rem;\n    }\n  }\n\n  @supports (display: grid) {\n    display: grid;\n    grid-row-gap: 2rem;\n\n    & > *:not(:last-child) {\n      margin-bottom: 0;\n    }\n\n    @media all and (min-width: 40rem) {\n      grid-row-gap: 3rem;\n    }\n  }\n"], ["\n  background-color: #fafafa;\n  padding: 2rem 0;\n\n  & > *:not(:last-child) {\n    margin-bottom: 2rem;\n  }\n\n  @media (max-width: 20rem) {\n    width: 20rem;\n  }\n\n  @media all and (min-width: 40rem) {\n    padding: 3rem 0;\n\n    & > *:not(:last-child) {\n      margin-bottom: 3rem;\n    }\n  }\n\n  @supports (display: grid) {\n    display: grid;\n    grid-row-gap: 2rem;\n\n    & > *:not(:last-child) {\n      margin-bottom: 0;\n    }\n\n    @media all and (min-width: 40rem) {\n      grid-row-gap: 3rem;\n    }\n  }\n"])));
exports.default = SectionContainer;

var templateObject_1;
//# sourceMappingURL=SectionContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/SectionContainer/SectionContainer.js
// module id = 1378
// module chunks = 0